<template>
  <side-nav class="ut-z-10" v-cloak>

    <!--Navigation Header-->
    <template slot="header">
      <side-nav-agent-header
        :name="userFirstName"
        :agentkey="user.agentkey"
        :agentid="user.agentid"
        :imgRef="isAgent ? agent.imageurl : null" />
    </template>

    <!--Navigation Body-->
    <template slot-scope="props">

      <!-- AGENTS Section -->
      <side-nav-category v-if="!isSignUpPage"  @close-menu="props.closeNav" name="AGENTS">

        <side-nav-link
          v-if="isAgent || (isPrincipal && isPremier)"
          url="leads"
          className="lead-link"
          :params="{ak: agent.key, uk:user.key}">
          Leads
        </side-nav-link>

        <side-nav-link
          v-if="(isPrincipal || isManager) && isPremier"
          className="dashboard-link "
          url="dashboard"
          :params="{ak: agent.key, uk:user.key}"
          badge="PREMIER">
          Dashboard
        </side-nav-link>

        <side-nav-link
          v-if="(isPrincipal || isManager) && isPremier"
          className="dashboard-link"
          url="leadcohorts"
          :params="{uk:user.key}"
          badge="PREMIER">
          Lead Overview
        </side-nav-link>

        <side-nav-link
          v-if="showProspecting"
          className="prospecting-link"
          url="prospecting"
          :params="{ak: agent.key }">
          Prospecting
        </side-nav-link>

        <side-nav-link
          v-if="isAgent"
          className="review-link"
          url="account"
          hash="#your-reviews"
          :params="{ak: agent.key }">
          Reviews
        </side-nav-link>

      </side-nav-category>

      <!-- HELP Section -->
      <side-nav-category
        v-if="isAgent"
        name="HELP">

        <side-nav-link
          className="help-link"
          url="contact"
          :params="{ak: agent.key }">
          Contact us
        </side-nav-link>

      </side-nav-category>
    </template>
  </side-nav>
</template>

<script>

import { mapState, mapGetters } from 'vuex';
import SideNav from '@/components/SideNav/SideNav.vue';
import SideNavCategory from '@/components/SideNav/SideNavCategory.vue';
import SideNavLink from '@/components/SideNav/SideNavLink.vue';
import SideNavAgentHeader from '@/components/SideNavAgentHeader.vue';

export default {
  name: 'Navigation',
  components: {
    SideNavAgentHeader,
    SideNavCategory,
    SideNav,
    SideNavLink,
  },
  data() {
    return {
      showBuyerNetwork: false,
    };
  },
  computed: {
    ...mapState({
      agent: state => state.agentStore.agent,
      user: state => state.userStore.user,
      prospectorService: state => state.userStore.prospectorService,
      userProspectorStatus: state => state.userStore.userProspectorStatus,
    }),
    ...mapGetters('userStore', [
      'isAgent',
      'isProspectingAgent',
      'isPrincipal',
      'isManager',
      'isPremier',
      'hasProspectorService',
      'hasCRMIntegration',
    ]),
    isUser() {
      return !!this.user && !!this.user.key;
    },
    showProspecting() {
      return (this.isPrincipal && this.hasProspectorService)
        || (this.isProspectingAgent);
    },
    userFirstName() {
      return this.user.firstname ? this.user.firstname : '';
    },
    isSignUpPage() {
      return this.$route.name === 'signup';
    },
  },
  mounted() {
    // if (this.$route.params.uk) {
    //   this.$store.dispatch('userStore/loadUser', this.$route.params.uk);
    // }
    this.$store.subscribe((mutation, state) => {
      switch (mutation.type) {
        // case 'agentStore/setAgent':
        //   if (this.$route.params.ak) {
        //     this.$store.dispatch('userStore/loadUser', this.agent.userkey);
        //   }
        //   break;
        case 'userStore/setUser':
          this.$store.dispatch('userStore/loadUserProspectorStatus', this.user.key)
            .catch(error => console.error(error));
          break;
        default:
          break;
      }
    });
  },
  watch: {
    agent(newAgent) {
      if (newAgent.id) {
        this.checkBuyerNetwork();
      }
    },
  },
  methods: {
    checkBuyerNetwork() {
      const BreakException = {};

      this.$apiServices.oa.postcode.getMetadata(this.agent.agencypostcodeid)
        .then((metadataData) => {
          try {
            Object.keys(metadataData).forEach((key) => {
              const value = metadataData[key];
              if (value.postcodemetadatakey === 'buyers-agent-portal') throw BreakException;
            });
          } catch (e) {
            if (e !== BreakException) throw e;
            else this.showBuyerNetwork = true;
          }
        });
    },
  },
};

</script>

<style scoped>

</style>
